import { types, ICapability, CapabilityType } from '../types/capability'

export const initialState: ICapability = {
  isLoading: false,
  id: '',
  title: '',
  description: '',
  editionTypes: [],
  editionSubType: '',
  publishingLocation: null,
  promotionLevel: [],
  requiredMediaTypeGroupId: '',
  requiredMediaTypeGroupTitle: '',
  supportedMediaTypeGroupId: '',
  supportedMediaTypeGroupTitle: '',
  excludeMediaTypeGroupId: '',
  excludeMediaTypeGroupTitle: '',
  lifetime: '',
  created: '',
  createdBy: {
    name: '',
    id: '',
  },
  requiresApproval: false,
  approved: false,
}

export const capability = (state = initialState, action: CapabilityType) => {
  switch (action.type) {
    case types.GET_CAPABILITY_BY_ID__STARTED:
    case types.CREATE_CAPABILITY__STARTED:
    case types.DELETE_CAPABILITY__STARTED:
      return { ...state, isLoading: true }
    case types.UPDATE_CAPABILITY__STARTED:
      return { ...state, ...action.capabilityData, isLoading: true }
    case types.GET_CAPABILITY_BY_ID__SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.capabilityData,
      }
    case types.CREATE_CAPABILITY__SUCCESS:
    case types.UPDATE_CAPABILITY__SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.capabilityData,
        message: action.message,
      }
    case types.GET_CAPABILITY_BY_ID__FAILURE:
    case types.UPDATE_CAPABILITY__FAILURE:
    case types.DELETE_CAPABILITY__SUCCESS:
    case types.DELETE_CAPABILITY__FAILURE:
    case types.CREATE_CAPABILITY__FAILURE:
      return { ...state, isLoading: false, message: action.message }
    default:
      return state
  }
}
